<!-- 顶部全宽提示组件 -->
<template>
  <transition name="el-zoom-in-top">
    <div 
      v-if="isShow" 
      :class="`top-warning is-${type}`"
      :style="{ zIndex }"
      @mouseenter="clearTimer"
      @mouseleave="startTimer"
    >
      <div class="top-warning__content">
        <i class="el-icon-warning" />
        <!-- 提示内容 -->
        <p>{{ content }}</p>
        <!-- 关闭按钮 -->
        <div v-if="showClose" @click="close">
          关闭
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "TopWarning",
  data() {
    return {
      isShow: false,
      showClose: true, // 是否显示关闭按钮
      duration: 0, // 显示时间, 毫秒。设为 0 则不会自动关闭
      timer: null, // 定时器
      type: 'warning', // warning, error
      content: '', // 提示内容
    }
  },
  methods: {
    handleEmit() {
      this.$nextTick(() => {
        this.$emit('isShowChange', this.isShow)
      })
    },
    open() {
      this.isShow = true
      this.handleEmit()
      this.startTimer()
      this.onOpen && this.onOpen()
    },
    close() {
      this.isShow = false
      this.content = ''
      this.handleEmit()
      this.clearTimer()
      this.onClose && this.onClose()
    },
    // 清除定时器
     clearTimer() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
    },
    // 开始计时
    startTimer() {
      // 如果 duration 为 0 或负数，表示不自动关闭
      if (this.duration <= 0) {
        return
      }
      
      this.clearTimer()
      this.timer = setTimeout(() => {
        this.close()
      }, this.duration)
    },
  }
};
</script>

<style lang="scss" scoped>
.top-warning {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  background: rgba(230, 162, 60, 0.95);
  box-shadow: 0px 3px 8px 0px rgba(0,0,0,0.22); 
  // &.is-warning {
  // }
  &.is-error {
    background: rgba(255, 77, 79, 0.95);
  }
  .top-warning__content {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFF;
    font-size: 15px;
    >i {
      font-size: 18px;
    }
    >p {
      margin: 0 30px 0 8px;
    }
    >div {
      width: 46px;
      height: 24px;
      line-height: 24px;
      font-size: 12px;
      text-align: center;
      cursor: pointer;
      border-radius: 12px;
      background: rgba(255, 255, 255, 0.33);
    }
  }
}
</style>